import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';

import { Button } from 'dibs-elements/exports/Button.tsx';
import { PageLayout } from 'dibs-elements/exports/PageLayout.tsx';
import { trackEvent } from 'dibs-tracking';

import styles from './ContemporaryLandingVideoModule.scss';

const VIMEO_LINK = 'https://player.vimeo.com/video/';

const trackClick = item => {
    trackEvent({
        action: 'featured maker profile',
        category: 'contemporary landing page interaction',
        event: 'e_ga_event',
        label: `view store clicked|${item.url}`,
    });
};

const ContemporaryLandingVideoModuleComponent = ({ contemporaryLandingVideo }) => {
    if (!contemporaryLandingVideo) {
        return null;
    }

    return (
        <PageLayout setViewportBackground>
            <div className={`rowFlex rowXsCenter ${styles.wrapper}`}>
                <div className="colXs12 colLg6 colLgFirst">
                    <div className={styles.info}>
                        {contemporaryLandingVideo.subtitle && (
                            <p className={styles.subtitle}>{contemporaryLandingVideo.subtitle}</p>
                        )}
                        <p className={styles.title}>{contemporaryLandingVideo.title}</p>
                        <p className={styles.description}>{contemporaryLandingVideo.description}</p>
                        <Button
                            href={contemporaryLandingVideo.url}
                            onClick={() => trackClick(contemporaryLandingVideo)}
                            className={styles.button}
                            size="medium"
                            type="transparent"
                        >
                            {contemporaryLandingVideo.cta}
                        </Button>
                    </div>
                </div>
                <div className="colXs12 colXsFirst colLg6">
                    <div className={styles.videoWrapper}>
                        {contemporaryLandingVideo.embedId && (
                            <iframe
                                className={styles.video}
                                src={`${VIMEO_LINK}${contemporaryLandingVideo.embedId}`}
                                width="640"
                                height="360"
                                frameBorder="0"
                                allowFullScreen
                                webkitallowfullscreen="true"
                                mozallowfullscreen="true"
                            />
                        )}
                    </div>
                </div>
            </div>
        </PageLayout>
    );
};

ContemporaryLandingVideoModuleComponent.propTypes = {
    video: PropTypes.object,
    contemporaryLandingVideo: PropTypes.object,
};

export const ContemporaryLandingVideoModule = createFragmentContainer(
    ContemporaryLandingVideoModuleComponent,
    {
        contemporaryLandingVideo: graphql`
            fragment ContemporaryLandingVideoModule_contemporaryLandingVideo on ContemporaryLandingVideo {
                ... on ContemporaryLandingVideo {
                    cta
                    description
                    embedId
                    subtitle
                    title
                    url
                }
            }
        `,
    }
);
